export type RecipientType = 'influencer' | 'contact' | 'brand';

export const EMAIL_DELIVERABILITY_REGEX =
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export function isValidEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const trimmed = email.trim();
  if (trimmed.length === 0) return false;
  return EMAIL_DELIVERABILITY_REGEX.test(trimmed);
}

interface BaseRecipient {
  readonly id: string;
  name: string;
  email: string;
  type: RecipientType;
  isDeliverable: boolean;
}

export interface InfluencerRecipient extends BaseRecipient {
  type: 'influencer';
  handle: string;
  platform: string;
  phone: string;
  avatar: string;
  sortName: string;
  campaignId?: string | null;
  campaign_id?: string | null;
}

export interface ContactRecipient extends BaseRecipient {
  type: 'contact';
  companyName?: string;
  designation?: string;
}

export interface BrandRecipient extends BaseRecipient {
  type: 'brand';
  industry?: string;
  logoUrl?: string;
}

export type RecipientItem = InfluencerRecipient | ContactRecipient | BrandRecipient;

export interface RecipientRef {
  id: string;
  type: RecipientType;
  campaign_id?: string | null;
}
